import React from 'react';
import PropTypes from 'prop-types';
import LayoutLoggedIn from 'components/Layout/LayoutLoggedIn';
import LayoutNotLoggedIn from 'components/Layout/LayoutNotLoggedIn';
import { isFullSiteMode, isMobileDevice } from 'utils/fullSite';
import debounce from 'lodash/debounce';

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.updateDimensions = debounce(this.updateDimensions.bind(this), 50, {
      leading: true,
      trailing: false,
    });
    this.state = {
      isMobileDevice: false,
    };

    this.metaObserver;
  }

  componentDidMount() {
    this.setState({
      isMobileDevice: isMobileDevice(),
    });
    window.addEventListener('resize', this.updateDimensions);

    const viewportMeta = document.getElementById('viewport-meta');
    this.metaObserver = new MutationObserver(() => {
      setTimeout(() => {
        this.setState({
          isMobileDevice: isMobileDevice(),
        });
      }, 100);
    });
    this.metaObserver.observe(viewportMeta, {
      attributes: true,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);

    this.metaObserver.disconnect();
  }

  updateDimensions() {
    this.setState({
      isMobileDevice: isMobileDevice(),
    });
  }

  render() {
    const { loggedIn, location, children } = this.props;

    // TODO optimize this to only 1 element
    let Component = LayoutNotLoggedIn;
    if (loggedIn && (!this.state.isMobileDevice || isFullSiteMode())) {
      Component = LayoutLoggedIn;
    }

    return <Component location={location}>{children}</Component>;
  }
}

Layout.propTypes = {
  location: PropTypes.object,
  children: PropTypes.object,
  loggedIn: PropTypes.bool,
};

export default Layout;
